<template>
  <div class="child-page-div">
    <div class="page-content-div">
      <div class="page-title-div">添加资讯</div>
      <validation-observer ref="form">
        <div class="item-div item-common-div">
          <div class="item-title-div">文章标题：</div>
          <div>
            <validation-provider rules="required|minmax:1,20" v-slot="{ errors }" name="newsName">
              <label>
                <input type="text" v-model="newsName" maxlength="20" placeholder="请输入文章标题">
              </label>
              <label class="tips-label err-tips">{{ errors[0] }}</label>
            </validation-provider>
          </div>
        </div>
        <div class="item-div item-common-div">
          <div class="item-title-div">文章摘要：</div>
          <div>
            <validation-provider rules="required|minmax:1,60" v-slot="{ errors }" name="newsRemark">
              <label>
                <input type="text" v-model="newsRemark" maxlength="60" placeholder="请输入文章摘要">
              </label>
              <label class="tips-label err-tips">{{ errors[0] }}</label>
            </validation-provider>
          </div>
        </div>
        <div class="item-div item-common-div">
          <div class="item-title-div">发布地区：</div>
          <div>
            <label>
              <select class="province-select" v-model="newsProvince">
                <option value="">全国</option>
                <option v-for="item in provinces" :value="item.id">{{item.name}}</option>
              </select>
            </label>
          </div>
        </div>
        <div class="item-div item-common-div">
          <div class="item-title-div">文章图片：</div>
          <div class="news-img-div">
            <div v-show="newsImg != null" class="img-div">
              <img ref="newsImg" src="" alt="">
            </div>
            <label class="upload-label" @change="onAddImg($event)">
              选择图片
              <input class="cursor-el" type="file" />
            </label>
          </div>
        </div>
        <div class="item-div">
          <div class="item-title-div">文章内容：</div>
          <div class="tinymce-div">
            <tinymce class="tinymce" v-model="newsContent"/>
          </div>
        </div>
      </validation-observer>
      <div class="submit-div">
        <div class="tips-div text-c err-tips">{{ tipMsg }}</div>
        <input type="button" value="添加资讯" @click="onSubmit">
      </div>
    </div>
  </div>
</template>

<script>
import Tinymce from "../../components/Tinymce"
import { getProvinces, postNewsAdd } from "../../common/api";

export default {
  name: "NewsAdd",
  components: { Tinymce },
  data() {
    return {
      provinces: [],
      newsName: "",
      newsRemark: "",
      newsProvince: "",
      newsImg: null,
      newsContent: "",
      tipMsg: ""
    }
  },
  created() {
    this.doGetProvinces();
  },
  methods: {
    doGetProvinces() {
      getProvinces()
          .then(data => {
            this.provinces = data;
          })
          .catch(error => {
            if (Object.prototype.hasOwnProperty.call(error, "data") && Object.prototype.hasOwnProperty.call(error.data, "status")) {
              this.$layer.msg(error.data.msg);
            } else {
              this.$layer.msg("查询省份信息失败，请稍后重试");
            }
          });
    },
    onAddImg(event) {
      if(event.target.files.length < 1){
        return;
      }

      if(!/\.(jpg|jpeg|png)$/.test(event.target.files[0].name.toLowerCase())){
        event.target.value = "";
        this.$layer.msg("图片类型仅支持jpg、jpeg和png格式");
        return;
      }

      let img = event.target.files[0];
      let that = this;
      let reader = new FileReader();
      reader.readAsDataURL(img);
      reader.onload = function() {
        that.$refs.newsImg.src = reader.result;
        that.newsImg = img;
        event.target.value = null;
      };
      reader.onerror = function() {
        that.newsImg = null;
        that.$refs.newsImg.src = null;
        that.$layer.msg("读取文件失败，请重试");
      };
    },
    onSubmit() {
      if(this.newsImg == null){
        this.setTipsMsg("请选择图片");
        return;
      }
      if(this.newsContent.length < 1){
        this.setTipsMsg("请输入文章内容");
        return;
      }

      this.$refs.form.validate().then(res => {
        if(res){
          let formData = new FormData();
          formData.append("title", this.newsName);
          formData.append("remark", this.newsRemark);
          formData.append("province", this.newsProvince);
          formData.append("content", this.newsContent);
          formData.append("file", this.newsImg)
          postNewsAdd(formData)
            .then(() => {
              this.newsName = "";
              this.newsRemark = "";
              this.newsImg = null;
              this.newsContent = "";
              this.setTipsMsg("操作成功");
            })
            .catch(error => {
              if (Object.prototype.hasOwnProperty.call(error, "data") && Object.prototype.hasOwnProperty.call(error.data, "status")) {
                this.setTipsMsg(error.data.msg);
              } else {
                this.setTipsMsg("操作失败");
              }
            });
        }
      });
    },
    setTipsMsg(msg) {
      this.tipMsg = msg;
      clearTimeout(this.timeCounter);
      this.timeCounter = setTimeout(() => {
        this.tipMsg = "";
      }, 3000);
    }
  }
}
</script>

<style lang="less" scoped>
.child-page-div {
  width: 100%;
  .page-content-div {
    border-radius: 5px;
    background-color: #ffffff;
    padding: 30px 20px 10px 20px;
    .page-title-div {
      font-size: 17px;
      font-weight: bold;
      padding-bottom: 10px;
      border-bottom: 1px solid #cccccc;
      margin-bottom: 10px;
    }
    .item-div {
      width: 100%;
      display: flex;
      margin-bottom: 10px;
      .item-title-div {
        width: 75px;
      }
      .province-select {
        height: 35px;
        border: 1px solid #dcdcdc;
      }
      .news-img-div {
        display: flex;
        align-items: center;
        .img-div {
          width: 100px;
          height: 60px;
          margin-right: 10px;
          img{
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
          }
        }
      }
      input {
        width: 500px;
        height: 33px;
        padding: 0 5px;
        border: 1px solid #dcdcdc;
      }
      .tinymce-div {
        width: 100%;
        .tinymce {
          width: 100%;
        }
      }
      .tips-label {
        margin-left: 5px;
      }
    }
    .item-common-div {
      align-items: center;
    }
    .submit-div {
      text-align: center;
      margin-top: 15px;
      input {
        width: 120px;
        height: 35px;
        color: white;
        font-size: 16px;
        border: none;
        background: #4676c8;
        margin-top: 10px;
      }
      .tips-div {
        width: 100%;
        height: 25px;
      }
    }
  }
}
</style>